// Models
import { AgentCurrentStatus, AgentStatus } from 'app/modules/agents/models';

// Responses
import {
  FullAgentResponse,
  NotificationEventGroups,
} from 'app/modules/agents/responses';

export const INITIAL_AGENT_DETAILS: FullAgentResponse = {
  accessible_queues: [],
  can_impersonate: false,
  created_at: '',
  current_status: null,
  default_org_display_name: '',
  default_org_id: 0,
  display_timezone: null,
  email: '',
  full_name: '',
  id: -1,
  is_default_login: true,
  is_reviewer: false,
  last_login_time: null,
  org_id: 0,
  org_name: '',
  picture: '',
  recently_merged: undefined,
  status: AgentStatus.INACTIVE,
  tags: [],
  teams: [],
  teams_permissions: {},
};

export const NOTIFICATION_EVENT_GROUP_ORDER = [
  NotificationEventGroups.ALERTS,
  NotificationEventGroups.CASES,
  NotificationEventGroups.SARS,
  NotificationEventGroups.RULES,
  NotificationEventGroups.DEADLINES,
  NotificationEventGroups.GENERAL,
  NotificationEventGroups.GLOBAL_TABLE_SETTINGS,
  NotificationEventGroups.FFIP_NOTIFICATION,
];

export const NOTIFICATION_EVENT_GROUP_LABELS: Record<
  NotificationEventGroups,
  string
> = {
  [NotificationEventGroups.ALERTS]: 'Alert',
  [NotificationEventGroups.CASES]: 'Case',
  [NotificationEventGroups.DEADLINES]: 'Deadline',
  [NotificationEventGroups.GENERAL]: 'General',
  [NotificationEventGroups.MISC]: 'Miscellaneous',
  [NotificationEventGroups.RULES]: 'Rule',
  [NotificationEventGroups.SARS]: 'SAR',
  [NotificationEventGroups.GLOBAL_TABLE_SETTINGS]: 'Global Table Settings',
  [NotificationEventGroups.FFIP_NOTIFICATION]: 'FFIP Ingestion',
};

export const MAX_PROFILE_PIC_SIZE = 5 * 1024 * 1024;

export const DEFAULT_AGENT_CURRENT_STATUS = AgentCurrentStatus.AVAILABLE;

export const DISPLAY_TIMEZONE_PLACEHOLDER = 'Local time (browser default)';
